import { citiesDistributionConfig } from '@/lib/analytics/charts/tiktok/citiesDistributionConfig';
import { countriesDistributionConfig } from '@/lib/analytics/charts/tiktok/countriesDistributionConfig';
//charts
import { followerGrowthConfig } from '@/lib/analytics/charts/tiktok/followerGrowthHistory';
import { followersOnlineConfig } from '@/lib/analytics/charts/tiktok/followersOnline';
import { gainedLostFollowersHistoryConfig } from '@/lib/analytics/charts/tiktok/gainedLostFollowersHistory';
import { genderDistributionConfig } from '@/lib/analytics/charts/tiktok/genderDistribution';
import { followersEvolutionConfig } from '@/lib/analytics/kpis/tiktok/followersEvolution';
import { followersEvolutionPercentageConfig } from '@/lib/analytics/kpis/tiktok/followersEvolutionPercentage';
import { gainedFollowersConfig } from '@/lib/analytics/kpis/tiktok/gainedFollowersConfig';
import { lostFollowersConfig } from '@/lib/analytics/kpis/tiktok/lostFollowersConfig';
//kpis
import { totalFollowersConfig } from '@/lib/analytics/kpis/twitter/totalFollowers';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_33, SIZE_50, SIZE_FULL } from '@/lib/gridElements/size';

export const CommunityTiktokBusiness = [
    // line 1
    { ...totalFollowersConfig, orientation: ORIENTATION_VERTICAL, size: SIZE_33 },
    { ...followersEvolutionConfig, size: SIZE_33 },
    { ...followersEvolutionPercentageConfig, size: SIZE_33 },
    // line 2
    { ...gainedFollowersConfig, size: SIZE_50 },
    { ...lostFollowersConfig, size: SIZE_50 },
    // line 3
    { ...followerGrowthConfig, size: SIZE_50 },
    { ...gainedLostFollowersHistoryConfig, size: SIZE_50 },
    // line 4
    { ...countriesDistributionConfig, size: SIZE_50 },
    { ...citiesDistributionConfig, size: SIZE_50 },
    // line 5
    { ...genderDistributionConfig, size: SIZE_FULL },
    // line 6
    { ...followersOnlineConfig, size: SIZE_FULL }
];

export const requestTiktokBusinessParams = [
    [
        'followers',
        'followers_evolution',
        'followers_evolution_percentage',
        'followers_growth',
        'followers_online',
        'gained_followers',
        'lost_followers',
        'gained_lost_followers_history'
    ],
    ['countries_distribution', 'gender_distribution', 'cities_distribution']
];

export const requestTiktokBusinessOtherParameters = {
    countries_distribution: {
        type: countriesDistributionConfig.defaultFilter
    },
    cities_distribution: {
        type: citiesDistributionConfig.defaultFilter
    }
};
